<template>
  <input
    :value="displayValue"
    :placeholder="placeholder"
    :maxlength="maskLength"
    :class="inputClass"
    type="text"
    inputmode="numeric"
    @input="onInput"
    @blur="onBlur"
  />
</template>

<script>
export default {
  name: 'MaskedInput',
  props: {
    modelValue: { type: String, default: '' },
    mask: { type: String, required: true },
    placeholder: { type: String, default: '' },
    inputClass: { type: String, default: 'tbl-input' },
  },
  emits: ['update:modelValue'],
  computed: {
    maskSlots() {
      return [...this.mask].map(ch => ch === '#')
    },
    maskLength() { return this.mask.length },
    maxDigits() { return this.maskSlots.filter(Boolean).length },
    displayValue() {
      return this.format(this.onlyDigits(this.modelValue))
    },
  },
  methods: {
    onlyDigits(v) { return String(v || '').replace(/\D+/g, '') },
    format(rawDigits) {
      const digits = (rawDigits || '').slice(0, this.maxDigits)
      let out = ''
      let d = 0
      for (let i = 0; i < this.mask.length; i++) {
        const isSlot = this.maskSlots[i]
        if (isSlot) {
          if (d < digits.length) out += digits[d++]
          else break
        } else {
          out += this.mask[i]
        }
      }
      return out
    },
    onInput(e) {
      const raw = e.target.value
      const digits = this.onlyDigits(raw)
      const masked = this.format(digits)
      e.target.value = masked
      this.$emit('update:modelValue', masked)
    },
    onBlur(e) {
      const val = e.target.value
      if (!val) this.$emit('update:modelValue', '')
    }
  }
}
</script>

<style scoped>
</style>

